export default __webpack_public_path__ + "static/media/simp-screenshot.99407cfa.png";